import './emergencyCooldownManager'; // Import at the very top
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

const container = document.getElementById('root');

// Set up a MutationObserver to detect cooldown notifications in the DOM
if (typeof window !== 'undefined') {
  // Add circuit breaker for mutation observer
  let lastMutationUpdate = 0;
  const MUTATION_THROTTLE = 500; // 500ms throttle
  
  // Create a MutationObserver instance
  const cooldownObserver = new MutationObserver((mutations) => {
    // Circuit breaker for frequent updates
    const now = Date.now();
    if (now - lastMutationUpdate < MUTATION_THROTTLE) {
      return; // Skip if we updated too recently
    }
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // Check if our cooldown broadcast element was added
        const cooldownElement = document.getElementById('training-cooldown-broadcast');
        if (cooldownElement && cooldownElement.dataset.cooldown) {
          lastMutationUpdate = now;
          const cooldownTime = new Date(cooldownElement.dataset.cooldown);
          
          // Dispatch an event so all components can update
          window.dispatchEvent(new CustomEvent('TRAINING_COOLDOWN_IMMEDIATE', {
            detail: { 
              cooldown: cooldownTime, 
              timestamp: Date.now(),
              source: 'mutation-observer'
            }
          }));
          
          console.log('MutationObserver detected cooldown DOM update:', cooldownTime.toISOString());
        }
      }
    });
  });
  
  // Start observing with a more limited configuration
  cooldownObserver.observe(document.body, { childList: true, subtree: true });
  
  // Set up localStorage change monitoring with circuit breaker
  let lastStorageItemUpdate = 0;
  const STORAGE_ITEM_THROTTLE = 300; // 300ms throttle
  
  const originalSetItem = localStorage.setItem;
  localStorage.setItem = function(key, value) {
    // Call the original setItem
    originalSetItem.call(this, key, value);
    
    // If this is a training cooldown update, broadcast it
    if (key === 'training_cooldown') {
      try {
        // Apply circuit breaker
        const now = Date.now();
        if (now - lastStorageItemUpdate < STORAGE_ITEM_THROTTLE) {
          return;
        }
        lastStorageItemUpdate = now;
        
        const cooldownTime = new Date(value);
        
        // Dispatch an event so all components can update
        window.dispatchEvent(new CustomEvent('STORAGE_TRAINING_COOLDOWN_UPDATED', {
          detail: { 
            cooldown: cooldownTime, 
            timestamp: Date.now(),
            source: 'localStorage-override'
          }
        }));
        
        console.log('localStorage override detected cooldown update:', cooldownTime.toISOString());
      } catch (err) {
        console.error('Error in localStorage override:', err);
      }
    }
  };
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
